export const credentialsTypes = {
  GET_CREDENTIALS_REQUEST: "GET_CREDENTIALS_REQUEST",
  GET_CREDENTIALS_SUCCESS: "GET_CREDENTIALS_SUCCESS",
  GET_CREDENTIALS_FAILURE: "GET_CREDENTIALS_FAILURE",

  POST_CREDENTIALS_REQUEST: "POST_CREDENTIALS_REQUEST",
  POST_CREDENTIALS_SUCCESS: "POST_CREDENTIALS_SUCCESS",
  POST_CREDENTIALS_FAILURE: "POST_CREDENTIALS_FAILURE",
};
